import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GlobalLoaderProvider } from "./contexts/GlobalLoaderContext";
import { GlobalModalProvider } from "./contexts/GlobalModalContext";
import { GlobalSelectedBranchProvider } from "./contexts/GlobalSelectedBranchContext";
import { store } from "./redux/store/configureStore";
import { GlobalDocModalProvider } from "contexts/GlobalDocModalContext";
var providers = [
    function(children) {
        return /*#__PURE__*/ _jsx(Provider, {
            store: store,
            children: children
        });
    },
    function(children) {
        return /*#__PURE__*/ _jsx(BrowserRouter, {
            basename: "/",
            children: children
        });
    },
    function(children) {
        return /*#__PURE__*/ _jsx(GoogleOAuthProvider, {
            clientId: "224450368848-n18vttkv84nf51a7hknmd22ph48s5mjq.apps.googleusercontent.com",
            children: children
        });
    },
    function(children) {
        return /*#__PURE__*/ _jsx(GlobalLoaderProvider, {
            children: children
        });
    },
    function(children) {
        return /*#__PURE__*/ _jsx(GlobalModalProvider, {
            children: children
        });
    },
    function(children) {
        return /*#__PURE__*/ _jsx(GlobalSelectedBranchProvider, {
            children: children
        });
    },
    function(children) {
        return /*#__PURE__*/ _jsx(GlobalDocModalProvider, {
            children: children
        });
    }
];
export var AppProviders = function(param) {
    var children = param.children;
    return providers.reduceRight(function(acc, ProviderFn) {
        return ProviderFn(acc);
    }, children);
};
